module.exports = __webpack_public_path__ + "img/20190706154909521.e4a28cbc.png";